import { Button } from "react-aria-components";
import { type AppTab, useAppStore } from "./app-store";

type NavItem = {
  id: AppTab;
  label: string;
  path: string;
};

type BottomNavigationProps = {
  disabled?: boolean;
};

const navItems: NavItem[] = [
  { id: "home", label: "Home", path: "M4 11.5 12 5l8 6.5V20h-5v-5H9v5H4z" },
  { id: "library", label: "Library", path: "M5 5h14v4H5zm0 6h14v8H5z" },
  { id: "create", label: "Create", path: "M11 5h2v6h6v2h-6v6h-2v-6H5v-2h6z" },
  { id: "account", label: "Account", path: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8m-7 8a7 7 0 0 1 14 0z" },
];

function Icon({ path }: { path: string }) {
  return (
    <svg aria-hidden="true" className="app-nav-icon" viewBox="0 0 24 24">
      <path d={path} />
    </svg>
  );
}

export function BottomNavigation({ disabled = false }: BottomNavigationProps) {
  const selectedTab = useAppStore((state) => state.selectedTab);
  const setSelectedTab = useAppStore((state) => state.setSelectedTab);

  return (
    <nav className="app-nav" aria-label="Primary">
      {navItems.map((item) => (
        <Button className="app-nav-item" aria-label={item.label} aria-current={selectedTab === item.id ? "page" : undefined} isDisabled={disabled} key={item.id} onPress={() => setSelectedTab(item.id)}>
          <Icon path={item.path} />
        </Button>
      ))}
    </nav>
  );
}
